import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Directive({
  selector: '[atxClickOutside]',
  standalone: false,
})
export class ClickOutsideDirective {
  @Input()
  public disabled = false;

  @Output()
  public clickOutside = new EventEmitter<void>();

  constructor(private host: ElementRef) {}

  @HostListener('document:click', ['$event'])
  public click(event: MouseEvent) {
    const clickedElement = event.target as HTMLElement;

    if (
      !this.disabled &&
      !this.host.nativeElement.contains(clickedElement) &&
      event.isTrusted &&
      !document
        .querySelector('.cdk-overlay-container')
        ?.contains(clickedElement) // exclude click events from other modals
    ) {
      this.clickOutside.emit();
    }
  }
}
